export const showProview = () => {
  const element = document?.getElementById("proview_root");
  if (element) {
    element.style.backgroundColor = "#000";
    element.style.display = "flex";
  }
};
